import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { ProgressBarModule } from 'primeng/progressbar';
import { ButtonModule } from 'primeng/button';
import { TranslocoModule } from '@jsverse/transloco';
import { EnrichedPack } from '../../model/pack';
import { PackLimitationsService } from '../../services/pack-limitations.service';
import { LimitedFeatures } from '../../models/pack.models';
import { GreentripperPinIconComponent } from '../greentripper-pin-icon/greentripper-pin-icon.component';

@Component({
  selector: 'app-display-pack-options',
  imports: [
    CommonModule,
    ProgressBarModule,
    ButtonModule,
    TranslocoModule,
    GreentripperPinIconComponent,
  ],
  templateUrl: './display-pack-options.component.html',
})
export class DisplayPackOptionsComponent {
  private packLimitationsService = inject(PackLimitationsService);

  @Input() pack?: EnrichedPack;
  @Input() usedTrips?: number;
  @Input() usedUsers?: number;
  @Input() displayCTA?: boolean = true;

  // Plain methods, not computed(): the inputs are decorator-based properties, not
  // signals, so a computed() would memoize the first value and never recompute.
  progressPercentageTrip(): number {
    const limit = this.pack?.tripLimit ?? 0;
    const used = this.usedTrips ?? 0;
    if (limit === 0) return 0;
    return Math.min(Math.round((used / limit) * 100), 100);
  }

  progressPercentageUsers(): number {
    const limit = this.pack?.userLimit ?? 0;
    const used = this.usedUsers ?? 0;
    if (limit === 0) return 0;
    return Math.min(Math.round((used / limit) * 100), 100);
  }

  dtProgressbar = {
    valueBackground: '{primary.500}',
    background: '{gray.200}',
  };

  get extraUsersUsed(): number {
    const totalUsers = this.usedUsers ?? 0;
    const includedUsers = this.pack?.userLimit ?? 0;
    return Math.max(0, totalUsers - includedUsers);
  }

  get extraUserLimit(): number | null {
    return this.pack?.extraUserLimit ?? null;
  }

  get hasLockedFeatures(): boolean {
    if (!this.pack) return false;
    return (
      !this.pack.exportPDF ||
      !this.pack.exportExcel ||
      !this.pack.clientFilter ||
      !this.pack.bulkUpload ||
      !this.pack.comparisonGraph
    );
  }

  openUpgradeModal(): void {
    this.packLimitationsService.openModal(LimitedFeatures.Generic);
  }

  openAddUserModal(): void {
    this.packLimitationsService.openModal(LimitedFeatures.CreateUser);
  }
  openAddTripModal(): void {
    this.packLimitationsService.openModal(LimitedFeatures.Trip);
  }
}
